import { Standard } from '@getvim/vim-connect';
import { referralIdA, referralIdB, referralIdC } from '../referrals';

export const predefinedPayloads: Record<string, Standard.Events.ReferralDeletedPayload> = {
  'Minnie Mouse - Raferral A': { referralId: referralIdA },
  'Steven Vazquez - Raferral B': { referralId: referralIdB },
  'Natasha Davies - Raferral C': { referralId: referralIdC },
};
